import { render } from "./error-box.vue?vue&type=template&id=1bc8f7f8"
import script from "./error-box.vue?vue&type=script&lang=js"
export * from "./error-box.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__